















/* eslint-disable */
import Component from 'vue-class-component';

import { IspecialistDetail, IgetDoctorSearchParam } from '@/store/specialist/index.d';
import { dispathGroupDoctorSearch } from '@/store/specialist';
import Webview from '@/webview';

@Component({
  name: 'GroupDoctorList',
})
export default class GroupDoctorList extends Webview {

  get telescopeMap() {
    return this.$route.meta.telescopeMap
  }

  specialists: IspecialistDetail[] = [];

  isLoading = false;

  isFinish = false;

  pageNo = 0;

  pageSize = 20;

  get noSpeicalist() {
    return this.specialists.length <= 0 && this.isFinish;
  }

  created() {
    this.search();
  }

  get groupType() {
    return this.$route.params.type && Number(this.$route.params.type) || 11
  }

  async search() {
    this.isLoading = true;

    this.pageNo += 1;

    const params: IgetDoctorSearchParam = {
      pageNo: this.pageNo,
      pageSize: this.pageSize,
    };
    let dispatch = dispathGroupDoctorSearch;

    const { count = 0, data } = await dispatch(this.$store, {
      ...params,
      doctorGroupType: this.groupType
    });

    this.specialists.push(...data);
    this.isLoading = false;
    this.isFinish = this.specialists.length >= count;
  }

}
